/*
 * Copyright 2026 NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

@Component({
  selector: "app-global-payments-details-edit",
  templateUrl: "./global-payments-details-edit.component.html"
})
export class GlobalPaymentsDetailsEditComponent {
  @Input() globalPaymentsFormGroup!: FormGroup;
}
